export interface SalesOrPurchaseOrderStockAllocation {
  id: string;
  stockItemId: string;
  salesOrderLineId: string;
  purchaseOrderLineId: string;
  stockNo: string;
  productKey: string;
  productDescription: string;
  productType: string;
  grade: string;
  holdStockAtProductLevel: boolean;
  balance: number;
  allocated: number;
  totalAllocated: number;
  freeStock: number;
  picked: number;
  warehouseKey: string;
  warehouseDescription: string;
  locationKey: string;
  locationDescription: string;
  batchNo: string;
  qtyRequired: number;
  selected: boolean;
  canDelete: boolean;
  despatched: number;
  deliveryDate: Date;
  allocateFullPieces: boolean;
  nettQuantity: number;
  hardAllocation: boolean;
  hardAllocationYesNo: string;
  imperial: boolean;
  nettQuantityImperial: number;
  totalAllocatedImperial: number;
  pickedImperial: number;
  freeOfChargeQuantity: boolean;
  allowFocQuantity: boolean;
  commentsExist: boolean;
  printLabel: boolean;
  salesDespatchNoteId: string;
  colour: string;
}
